import { memo, useCallback, useMemo } from 'react';
import { Box, Button, formatMoney, Image, Text } from '@betty/moonlight';
import { Trans } from '@betty/i18n';
import {
  BottomSheetExtendedProps,
  resetToRootNavigator,
  StackNavigationProp,
  useNavigation,
} from '@betty/navigation';

type WithdrawalCompletedProps = BottomSheetExtendedProps & {
  amount: number;
};

function WithdrawalCompleted({ amount }: WithdrawalCompletedProps) {
  const cash = useMemo(() => formatMoney(amount), [amount]);
  const navigation =
    useNavigation<StackNavigationProp<AppNavigatorParamsList>>();

  const onPrimaryPress = useCallback(() => {
    resetToRootNavigator(() => {
      navigation.navigate('Promos');
    });
  }, [navigation]);

  const onSecondaryPress = useCallback(() => {
    resetToRootNavigator(() => {
      navigation.navigate('TransactionHistory');
    });
  }, [navigation]);

  return (
    <Box alignItems="center" gap="space-600">
      <Box gap="space-400">
        <Image name="wallet.withdrawalCompleted" width={138} height={64} />
        <Text
          variant="h4"
          color="accentSurfacePrimary"
          locNS="wallet"
          locKey="withdrawal_completed_title"
        />
      </Box>
      <Text color="accentSurfacePrimary" variant="body-m" textAlign="center">
        <Trans
          ns="wallet"
          i18nKey="withdrawal_completed_message"
          values={{ amount: cash }}
        />
      </Text>
      <Box flexDirection="row" gap="space-200">
        <Button
          flex={1}
          locNS="wallet"
          locKey="withdrawal_completed_secondary_cta"
          variant="secondary"
          light
          onPress={onSecondaryPress}
        />
        <Button
          flex={1}
          locNS="wallet"
          locKey="withdrawal_completed_primary_cta"
          variant="primary"
          light
          onPress={onPrimaryPress}
        />
      </Box>
    </Box>
  );
}

export default memo(WithdrawalCompleted);
